import React, { useRef, useEffect } from 'react';
import { Box } from '@mui/material';
import { styled, keyframes } from '@mui/material/styles';

const WaveformContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '50px',
  gap: '3px',
}));

const waveAnimation = keyframes`
  0% {
    height: '5px';
  }
  50% {
    height: '30px';
  }
  100% {
    height: '5px';
  }
`;

const WaveBar = styled(Box)<{ index: number }>(({ theme, index }) => ({
  width: '4px',
  height: '5px',
  borderRadius: '2px',
  background: 'linear-gradient(to bottom, #8A2BE2, #00CC99)',
  animation: `${waveAnimation} 1.2s ease-in-out infinite`,
  animationDelay: `${index * 0.1}s`,
}));

const VoiceWaveform: React.FC = () => {
  const waveformRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    // In a real implementation, this would be connected to actual audio levels
    // For now, we'll just create a visual effect
    const interval = setInterval(() => {
      if (waveformRef.current) {
        const bars = waveformRef.current.querySelectorAll('div');
        bars.forEach((bar) => {
          const randomHeight = Math.floor(Math.random() * 25) + 5;
          bar.style.height = `${randomHeight}px`;
        });
      }
    }, 100);
    
    return () => clearInterval(interval);
  }, []);
  
  return (
    <WaveformContainer ref={waveformRef}>
      {Array.from({ length: 10 }).map((_, index) => (
        <WaveBar key={index} index={index} />
      ))}
    </WaveformContainer>
  );
};

export default VoiceWaveform; 